/* Theme-local presentation for the existing Free + True Klaviyo form. */
(function () {
  'use strict';

  if (window.__ftNewsletterPopup) return;
  window.__ftNewsletterPopup = true;

  var FORM_ID = 'V2TWDY';
  var THEME_ID = '159909740699';
  var FORM_SELECTOR = 'form[data-testid="klaviyo-form-' + FORM_ID + '"]';
  var headingId = 'rich-text-016JB91TTR00000000000YT05B';
  var bodyId = 'rich-text-016JB91TTR00000000000YT05C';
  var welcomeId = 'rich-text-016JB91TTR00000000000YT05A';
  var desktopPhoto = 'https://cdn.shopify.com/s/files/1/0195/2946/5956/files/1W_yxeu44jbKJeU4PXJlVD-bo4Y4Rdj0A_w2400.jpg?v=1789585728';
  var mobilePhoto = 'https://cdn.shopify.com/s/files/1/0195/2946/5956/files/1GdMRAM3_rTHNn1vB4i4sm7GDem-qdi_x_w2400.jpg?v=1790939186';
  var mobileLayout = window.matchMedia('(max-width: 640px)');
  var scheduled = false;

  function richText(form, id) {
    return form.querySelector('[id="' + id + '"], [data-testid="' + id + '"]');
  }

  function setCopy(element, copy, className) {
    if (!element) return;
    element.classList.add(className);
    if (element.textContent !== copy) element.textContent = copy;
  }

  function setPhoto(media) {
    var photo = mobileLayout.matches ? mobilePhoto : desktopPhoto;
    var alt = mobileLayout.matches
      ? 'A woman smiling in a sunlit forest.'
      : 'A woman holding Balanced Being in the forest.';
    var image = media.querySelector('img');
    if (!image) {
      image = document.createElement('img');
      media.appendChild(image);
    }
    var src = photo + '&width=1000';
    var srcset = [600, 1000, 1400].map(function (width) {
      return photo + '&width=' + width + ' ' + width + 'w';
    }).join(', ');
    var sizes = '(max-width: 640px) calc(100vw - 32px), 396px';
    if (image.getAttribute('src') !== src) image.setAttribute('src', src);
    if (image.getAttribute('srcset') !== srcset) image.setAttribute('srcset', srcset);
    if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
    if (image.getAttribute('alt') !== alt) image.setAttribute('alt', alt);
    media.querySelectorAll('source').forEach(function (source) {
      if (source.getAttribute('srcset') !== srcset) source.setAttribute('srcset', srcset);
      if (source.getAttribute('sizes') !== sizes) source.setAttribute('sizes', sizes);
    });
  }

  function decorate(form) {
    var heading = richText(form, headingId);
    var body = richText(form, bodyId);
    var welcome = richText(form, welcomeId);

    // Exact block IDs limit copy changes to the existing signup step.
    setCopy(heading, 'Your first order,\n15% off.', 'ft-newsletter-popup__heading');
    setCopy(body, 'Join Free + True for 15% off your first order and two free deluxe samples.', 'ft-newsletter-popup__body');
    if (welcome) {
      (welcome.closest('[data-testid="form-row"]') || welcome).classList.add('ft-newsletter-popup__welcome-row');
    }

    var submit = form.querySelector('button[data-action-id="016JB91VT000000000000CZKB2"]');
    // Never replace a button node or its action/submit handler.
    if (submit && /^get\s+(?:my\s+)?code$/i.test(submit.textContent.trim())) {
      setCopy(submit, 'Get my code', 'ft-newsletter-popup__submit');
    }

    // Keep the original form and all field/action nodes in place.
    var columns = Array.prototype.filter.call(form.children, function (child) {
      return child.tagName === 'DIV';
    });
    var content = heading && columns.find(function (column) { return column.contains(heading); });
    var media = content && columns.find(function (column) {
      return column !== content && column.querySelector('img');
    });
    if (content) content.classList.add('ft-newsletter-popup__content');
    // Some mobile form variants omit the original image column entirely.
    if (content && !media) {
      media = document.createElement('div');
      form.insertBefore(media, content);
    }
    if (media) {
      media.classList.add('ft-newsletter-popup__media');
      setPhoto(media);
    }

    var modal = form.closest('[data-testid="modal-form-container"]');
    if (modal) modal.classList.add('ft-newsletter-modal');
  }

  function refresh() {
    scheduled = false;
    document.querySelectorAll(FORM_SELECTOR).forEach(decorate);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  }

  function concernsPopup(node) {
    var element = node.nodeType === 1 ? node : node.parentElement;
    return element && (
      element.matches(FORM_SELECTOR) ||
      element.closest(FORM_SELECTOR) ||
      element.querySelector(FORM_SELECTOR)
    );
  }

  function init() {
    refresh();
    // Klaviyo mounts asynchronously and can replace its copy after validation.
    var observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return concernsPopup(mutation.target) ||
          Array.prototype.some.call(mutation.addedNodes, concernsPopup);
      })) schedule();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });
    if (mobileLayout.addEventListener) mobileLayout.addEventListener('change', schedule);
    else mobileLayout.addListener(schedule);

    var params = new URLSearchParams(window.location.search);
    var activeThemeId = window.Shopify && window.Shopify.theme && String(window.Shopify.theme.id);
    var isPreviewTheme = activeThemeId ? activeThemeId === THEME_ID : params.get('preview_theme_id') === THEME_ID;
    if (isPreviewTheme && params.get('ft_preview_popup') === '1') {
      // Official queue API: safe before Klaviyo.js loads. Preview request only.
      // https://developers.klaviyo.com/en/docs/how_to_custom_trigger_a_popup_or_flyout_form
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', FORM_ID]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

